import type { StylesConfig } from 'react-select';
import type { SelectOption } from './selectTypes';

export const FILTER_SELECT_WIDTH: number | string = 250;

export const filterSelectStyles = <IsMulti extends boolean = false>(
  width: number | string = FILTER_SELECT_WIDTH,
): StylesConfig<SelectOption, IsMulti> => ({
  container: (base) => ({ ...base, width }),
  control: (base, state) => ({
    ...base,
    minHeight: 34,
    borderRadius: 4,
    borderColor: state.isFocused ? '#66afe9' : '#d2d6de',
    boxShadow: state.isFocused ? 'inset 0 1px 1px rgba(0,0,0,.075), 0 0 0 3px rgba(102,175,233,.2)' : 'none',
    '&:hover': { borderColor: state.isFocused ? '#66afe9' : '#d2d6de' },
    backgroundColor: state.isDisabled ? '#eee' : '#fff',
    fontSize: 14,
  }),
  valueContainer: (base) => ({ ...base, padding: '2px 8px' }),
  input: (base) => ({ ...base, margin: 0, padding: 0 }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (base) => ({ ...base, padding: '4px 8px', color: '#999' }),
  clearIndicator: (base) => ({ ...base, padding: '4px 6px', color: '#999' }),
  placeholder: (base) => ({ ...base, color: '#999' }),
  singleValue: (base) => ({ ...base, color: '#555' }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: '#f5f5f5',
    border: '1px solid #e3e3e3',
    borderRadius: 2,
  }),
  multiValueLabel: (base) => ({ ...base, color: '#333', fontSize: 12, padding: '2px 4px' }),
  multiValueRemove: (base) => ({
    ...base,
    color: '#999',
    ':hover': { backgroundColor: '#e3e3e3', color: '#555' },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 30,
    marginTop: 2,
    border: '1px solid #ccc',
    borderRadius: 4,
    boxShadow: '0 2px 6px rgba(0,0,0,.1)',
  }),
  menuList: (base) => ({ ...base, padding: 0, maxHeight: 200 }),
  option: (base, state) => ({
    ...base,
    fontSize: 14,
    padding: '8px 10px',
    backgroundColor: state.isSelected ? '#f5f5f5' : state.isFocused ? '#deebff' : '#fff',
    color: '#333',
    cursor: 'pointer',
    ':active': { backgroundColor: '#deebff' },
  }),
});
